var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSquareHalf = function SvgIconSquareHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.875 19.125a1.75 1.75 0 0 1-1.75 1.75H4.875a1.75 1.75 0 0 1-1.75-1.75V4.875c0-.966.784-1.75 1.75-1.75h14.25c.966 0 1.75.784 1.75 1.75zm-15.75-14v13.75H11V5.125zm7.875 12v1.75h5.875v-1.75zm5.875-2H13V13h5.875zM13 11h5.875V8.875H13zm5.875-4.125H13v-1.75h5.875z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSquareHalf;